import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// warehouses — คลังสินค้า (Warehouse)
// ============================================================================
export const warehouses = sqliteTable("inventory_warehouses", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  code: text("code").notNull(),
  name: text("name").notNull(),
  location: text("location"),
  isDefault: integer("is_default").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  // Audit
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  wh_company_idx: index("wh_company_idx").on(table.companyId, table.isActive),
}));

// Type exports
export type Warehouse = typeof warehouses.$inferSelect;
export type NewWarehouse = typeof warehouses.$inferInsert;
